<template>
    <div class="modal-content tw-text-left tw-px-6 tw-relative">
        <div class="tw-flex tw-justify-between tw-items-center tw-pb-6 tw-sticky tw-top-0 tw-left-0 tw-w-full tw-pt-6 tw-bg-white">
            <h4 class="tw-font-bold tw-text-lg">{{ $t('privacyPolicy.title') }}</h4>
            <div class="modal-close tw-cursor-pointer tw-z-50" @click="$store.dispatch('closeAllModals')">
                <svg class="tw-fill-current" xmlns="http://www.w3.org/2000/svg" width="17.639" height="17.567" viewBox="0 0 17.639 17.567">
                    <g transform="translate(16.821 16.749) rotate(180)">
                        <path d="M389.1,2434l7.28-7.282a.421.421,0,0,0,0-.6.425.425,0,0,0-.594,0l-7.281,7.283-7.281-7.283a.421.421,0,0,0-.595.6l7.281,7.282-7.281,7.281a.421.421,0,0,0,.6.6l7.281-7.281,7.281,7.281a.418.418,0,0,0,.3.123.421.421,0,0,0,.3-.719L389.1,2434Z" transform="translate(-380.503 -2426.001)" fill="#ccc" stroke="#ccc" stroke-width="1.5" />
                    </g>
                </svg>
            </div>
        </div>
        <div class="tw-max-h-3/4 tw-h-64 tw-overflow-y-auto">
            <h4>
                1. IDENTIFICAÇÃO
            </h4>
            <p>
                <b>Titular:</b> MAKRO CASH & CARRY PORTUGAL S.A. (a seguir designada "MAKRO") <br>
                <b>NIPC</b>: 502030712 <br>
                <b>Sede social</b>: Rua Quinta do Paizinho, 1, Portela de Carnaxide, 2794-066 Carnaxide <br>
                Matriculada na Conservatória do Registo Comercial de Cascais <br>
                <b>Telefones e e-mails de contacto</b>: disponíveis na secção de Contactos no site <br>
            </p>
            <h4>
                2. INFORMAÇÃO E AUTORIZAÇÃO
            </h4>
            <p>
                Em conformidade com a lei, mediante a aceitação da presente Política de Privacidade, o Utilizador fica informado e dá o seu consentimento informado, expresso, livre e inequívoco para que os dados pessoais facultados através da página Web localizada no URL www.makro.pt (a seguir designado "Sítio Web") sejam incluídos nos ficheiros que são propriedade da MAKRO PORTUGAL CASH&CARRY S.A., após notificação da Comissão Nacional de Proteção de Dados da realização do tratamento de tais dados.
            </p>
            <h4>
                3. OBRIGATORIEDADE DE FACULTAR DADOS
            </h4>
            <p>
                Os dados solicitados nos formulários da Web são de caráter geral, obrigatórios (salvo indicação em contrário no campo requerido) e têm as finalidades indicadas. Por esse motivo, se os dados não forem facultados ou se não forem corretamente facultados, não será possível concretizar essas finalidades, sem prejuízo da livre visualização do conteúdo do Sítio Web.
            </p>
            <h4>
                4. COM QUE FINALIDADE TRATA A MAKRO OS DADOS DOS UTILIZADORES?
            </h4>
            <p>
                Os dados pessoais facultados pelos UTILIZADORES serão tratados pela MAKRO com as seguintes finalidades:
            </p>
            <p>
                Os dados facultados pelos clientes MAKRO nos diferentes formulários durante o processo de registo destinam-se a assegurar a manutenção, administração e gestão da relação estabelecida e do serviço de apoio ao cliente, bem como a manter os clientes informados e/ou obter a sua opinião sobre promoções, produtos e serviços da MAKRO e das empresas suas parceiras que possam ser do seu interesse, recorrendo para o efeito a qualquer meio, incluindo as comunicações por correio electrónico e por outros meios eletrónicos. <br>
                Gerir o registo do Utilizador e conferir-lhe acesso aos produtos e serviços oferecidos na área de cliente. <br>
                Gerir, processar e dar resposta a pedidos, reações, ocorrências ou consultas do Utilizador sempre que este facultar os seus dados através dos formulários previstos para o efeito. <br>
                Apreciar a candidatura do Utilizador e, se for caso disso, integrá-lo nos processos de seleção compatíveis com o seu perfil, na eventualidade de o Utilizador ter enviado o seu Curriculum Vitae. <br>
                Enviar regularmente aos UTILIZADORES, incluindo por meios eletrónicos, newsletters e boletins informativos relacionados com produtos, serviços, promoções, ofertas, eventos ou notícias que possam ser do seu interesse, sempre que os o tenham solicitado através do formulário "Quero receber a Newsletter da MAKRO". <br>
            </p>
            <h4>
                5. QUE AÇÕES A MAKRO NÃO REALIZARÁ?
            </h4>
            <p>
                A MAKRO nunca realizará as seguintes ações em relação aos dados pessoais facultados:
            </p>
            <p>
                Ceder os dados a outras pessoas ou entidades sem o consentimento prévio do Utilizador. <br>
                Transferir os dados para fora do Espaço Económico Europeu sem o consentimento prévio do Utilizador. <br>
            </p>
            <h4>
                6. RESPONSABILIDADE DO UTILIZADOR
            </h4>
            <p>
                O Utilizador:
            </p>
            <p>
                Assegura que tem mais de 18 anos e que os dados que faculta à MAKRO são verdadeiros, exatos, completos e atualizados. Para o efeito, o Utilizador é responsável pela veracidade de todos os dados que comunica e mantém a informação facultada convenientemente atualizada, de modo a corresponder à situação real. <br>
                Assegura que informa eventuais terceiros cujos dados faculte acerca dos aspetos abordados no presente documento. Assegura ainda que obteve a autorização desses terceiros para facultar os respetivos dados à MAKRO para os fins indicados. <br>
                É responsável pelas informações falsas ou inexatas que faculte através do Sítio Web e pelas perdas e danos, diretos ou indiretos, que estas causem à MAKRO ou a terceiros. <br>
            </p>
            <h4>
                7. COMUNICAÇÕES COMERCIAIS E PROMOCIONAIS
            </h4>
            <p>
                Uma das finalidades do tratamento que a MAKRO faz dos dados pessoais facultados pelos UTILIZADORES é o envio de comunicações eletrónicas com informações relativas a produtos, serviços, promoções, ofertas, eventos ou notícias relevantes para os UTILIZADORES. Sempre que sejam efetuadas comunicações deste tipo, estas serão endereçadas única e exclusivamente aos UTILIZADORES que tenham manifestado, de forma prévia e expressa, o seu consentimento para as receber. Os UTILIZADORES que pretendam deixar de receber comunicações comerciais ou promocionais da MAKRO podem cancelar o serviço na ligação disponibilizada para o efeito em todas as newsletters ou mediante o envio de um correio electrónico para o endereço contacto.cliente@makro.pt
            </p>
            <p>
                Nos termos do n.º 1 do artigo 13.º-A da Lei n.º 46/2012 de 29 de Agosto, o envio de comunicações publicitárias não solicitadas está dependente do consentimento prévio e expresso do utilizador do website. Esta regra não se aplica no caso de os assinantes serem empresas ou pessoas colectivas, sendo permitidas as comunicações não solicitadas para fins de marketing direto até que os assinantes recusem futuras comunicações e se inscrevam na lista, gerida pela Direcção-Geral do Consumidor, de pessoas colectivas que manifestem expressamente opor-se à recepção de comunicações não solicitadas para fins de marketing direto (n.º 2 do artigo 13.º-A).
            </p>
            <p>
                A lei prevê também (n.º 3 do mesmo artigo 13.º-A) que o fornecedor de determinado produto que tenha obtido dos seus clientes, no contexto da venda de um produto ou serviço, as respectivas coordenadas electrónicas de contacto, possa utilizá-las para fins de marketing dos seus próprios produtos ou serviços, desde que garanta aos clientes, clara e explicitamente, a possibilidade de recusarem, de forma gratuita e fácil, a utilização de tais coordenadas: no momento da respectiva recolha; e por ocasião de cada mensagem, quando o cliente não tenha recusado inicialmente essa utilização.
            </p>
            <h4>
                8. EXERCÍCIO DE DIREITOS
            </h4>
            <p>
                O Utilizador pode exercer os seus direitos de acesso, retificação, cancelamento e oposição, mediante envio de pedido escrito indicando o(s) direito(s) que deseja exercer, acompanhado de cópia do cartão de cidadão ou de documento equivalente comprovativo de identificação, para um dos seguintes endereços:
            </p>
            <p>
                Correio postal: Rua Quinta do Paizinho, 1, Portela de Carnaxide, 2794-066 Carnaxide <br>
                Correio electrónico: contacto.cliente@makro.pt
            </p>
            <h4>
                9. POLÍTICA DE COOKIES
            </h4>
            <p>
                Os cookies são pequenos ficheiros de dados que se alojam nos terminais dos UTILIZADORES que visitam a página Web e que contêm determinadas informações sobre essa visita. A página Web utiliza cookies unicamente com o objetivo de facilitar a navegação dos UTILIZADORES e sem que nunca seja possível associar esses cookies aos dados pessoais concretos dos UTILIZADORES ou de os identificar através dos cookies. Contudo, a maior parte dos browsers permite que os UTILIZADORES desativem os cookies. Informamos os UTILIZADORES de que utilizamos cookies próprios e de terceiros para melhorar a sua experiência e os nossos serviços, mediante a análise da navegação no nosso sítio Web.
            </p>
            <p>
                Nos termos da lei, “o armazenamento de informações e a possibilidade de acesso à informação armazenada no equipamento terminal de um assinante ou utilizador apenas são permitidos se estes tiverem dado o seu consentimento prévio, com base em informações claras e completas” (n.º 1 do artigo 5.º da Lei n.º 41/2004, de 18 de Agosto). Assim, exige-se que os utilizadores de Internet deem o seu consentimento prévio à utilização de cookies, não bastando a simples não oposição pelos utilizadores para que essa utilização possa ter lugar. Como tal, qualquer entidade que pretenda depositar cookies no browser de um utilizador terá de obter o seu consentimento prévio e prestar-lhe ainda informações claras acerca da finalidade desse mecanismo. Assim fazemos nas nossas páginas que utilizam cookies.
            </p>
            <p>
                Para mais informações sobre cookies, consulte a nossa página informativa.
            </p>
            <h4>
                10. MEDIDAS DE SEGURANÇA
            </h4>
            <p>
                A MAKRO trata sistematicamente os dados dos UTILIZADORES de forma absolutamente confidencial, observando o dever de sigilo em relação aos mesmos, em conformidade com a legislação aplicável, e adotando, para o efeito, as medidas técnicas e organizacionais necessárias para garantir a segurança dos dados e evitar a sua alteração, perda, tratamento ou acesso não autorizados, tendo em conta o estado da tecnologia, a natureza dos dados armazenados e os riscos a que estão expostos
            </p>

            <h4>{{ $t('privacyPolicy.dataProcessor.title') }}</h4>
            <p>{{ $t('privacyPolicy.dataProcessor.text', { company:company }) }}</p>
        </div>
        <div class="terms-footer tw-sticky tw-bg-white tw-bottom-0 tw-py-6">
            <button type="button" class="btn-cta" @click.prevent="$store.state.privacyPolicy = true; $store.state.modal.terms = false;">
                {{ $t('privacyPolicy.accept') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Terms',
    data() {
        return {
            company: process.env.VUE_APP_COMPANY,
        };
    },
};
</script>

<style lang="scss" scoped>
    .terms-footer {
        .btn-cta {
            max-width: 100%;
        }
    }

    h4 {
        margin-bottom: 10px;
        font-weight: 700;
        font-size: 20px;
    }

    p {
        margin-bottom: 15px;
    }

</style>
